// Staff request list actions
export const LOAD_STAFF_ACCOMMODATION_REQUESTS = "LOAD_STAFF_ACCOMMODATION_REQUESTS";
export const LOAD_STAFF_ACCOMMODATION_REQUESTS_SUCCESS = "LOAD_STAFF_ACCOMMODATION_REQUESTS_SUCCESS";
export const LOAD_STAFF_ACCOMMODATION_REQUESTS_ERROR = "LOAD_STAFF_ACCOMMODATION_REQUESTS_ERROR";

// Staff request detail actions
export const LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL = "LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL";
export const LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_SUCCESS = "LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_SUCCESS";
export const LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_ERROR = "LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_ERROR";

// Staff request history actions
export const LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY = "LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY";
export const LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_SUCCESS = "LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_SUCCESS";
export const LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_ERROR = "LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_ERROR";

// Approve/Deny actions
export const APPROVE_ACCOMMODATION_REQUEST = "APPROVE_ACCOMMODATION_REQUEST";
export const APPROVE_ACCOMMODATION_REQUEST_SUCCESS = "APPROVE_ACCOMMODATION_REQUEST_SUCCESS";
export const APPROVE_ACCOMMODATION_REQUEST_ERROR = "APPROVE_ACCOMMODATION_REQUEST_ERROR";

export const DENY_ACCOMMODATION_REQUEST = "DENY_ACCOMMODATION_REQUEST";
export const DENY_ACCOMMODATION_REQUEST_SUCCESS = "DENY_ACCOMMODATION_REQUEST_SUCCESS";
export const DENY_ACCOMMODATION_REQUEST_ERROR = "DENY_ACCOMMODATION_REQUEST_ERROR";

export const BYPASS_APPROVE_ACCOMMODATION_REQUEST = "BYPASS_APPROVE_ACCOMMODATION_REQUEST";
export const BYPASS_APPROVE_ACCOMMODATION_REQUEST_SUCCESS = "BYPASS_APPROVE_ACCOMMODATION_REQUEST_SUCCESS";
export const BYPASS_APPROVE_ACCOMMODATION_REQUEST_ERROR = "BYPASS_APPROVE_ACCOMMODATION_REQUEST_ERROR";

// Add notes actions
export const ADD_ACCOMMODATION_NOTE = "ADD_ACCOMMODATION_NOTE";
export const ADD_ACCOMMODATION_NOTE_SUCCESS = "ADD_ACCOMMODATION_NOTE_SUCCESS";
export const ADD_ACCOMMODATION_NOTE_ERROR = "ADD_ACCOMMODATION_NOTE_ERROR";

// Document review actions
export const REVIEW_ACCOMMODATION_DOCUMENT = "REVIEW_ACCOMMODATION_DOCUMENT";
export const REVIEW_ACCOMMODATION_DOCUMENT_SUCCESS = "REVIEW_ACCOMMODATION_DOCUMENT_SUCCESS";
export const REVIEW_ACCOMMODATION_DOCUMENT_ERROR = "REVIEW_ACCOMMODATION_DOCUMENT_ERROR";

// Staff upload document actions
export const UPLOAD_STAFF_ACCOMMODATION_DOCUMENT = "UPLOAD_STAFF_ACCOMMODATION_DOCUMENT";
export const UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_SUCCESS = "UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_SUCCESS";
export const UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_ERROR = "UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_ERROR";

// Create on behalf actions
export const CREATE_ACCOMMODATION_REQUEST_ON_BEHALF = "CREATE_ACCOMMODATION_REQUEST_ON_BEHALF";
export const CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_SUCCESS = "CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_SUCCESS";
export const CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_ERROR = "CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_ERROR";

// Accommodation plan actions
export const LOAD_STAFF_ACCOMMODATION_PLAN = "LOAD_STAFF_ACCOMMODATION_PLAN";
export const LOAD_STAFF_ACCOMMODATION_PLAN_SUCCESS = "LOAD_STAFF_ACCOMMODATION_PLAN_SUCCESS";
export const LOAD_STAFF_ACCOMMODATION_PLAN_ERROR = "LOAD_STAFF_ACCOMMODATION_PLAN_ERROR";

export const CREATE_ACCOMMODATION_PLAN = "CREATE_ACCOMMODATION_PLAN";
export const CREATE_ACCOMMODATION_PLAN_SUCCESS = "CREATE_ACCOMMODATION_PLAN_SUCCESS";
export const CREATE_ACCOMMODATION_PLAN_ERROR = "CREATE_ACCOMMODATION_PLAN_ERROR";

export const UPDATE_ACCOMMODATION_PLAN = "UPDATE_ACCOMMODATION_PLAN";
export const UPDATE_ACCOMMODATION_PLAN_SUCCESS = "UPDATE_ACCOMMODATION_PLAN_SUCCESS";
export const UPDATE_ACCOMMODATION_PLAN_ERROR = "UPDATE_ACCOMMODATION_PLAN_ERROR";

// Letter actions
export const CREATE_ACCOMMODATION_LETTER = "CREATE_ACCOMMODATION_LETTER";
export const CREATE_ACCOMMODATION_LETTER_SUCCESS = "CREATE_ACCOMMODATION_LETTER_SUCCESS";
export const CREATE_ACCOMMODATION_LETTER_ERROR = "CREATE_ACCOMMODATION_LETTER_ERROR";

export const FINALISE_ACCOMMODATION_LETTER = "FINALISE_ACCOMMODATION_LETTER";
export const FINALISE_ACCOMMODATION_LETTER_SUCCESS = "FINALISE_ACCOMMODATION_LETTER_SUCCESS";
export const FINALISE_ACCOMMODATION_LETTER_ERROR = "FINALISE_ACCOMMODATION_LETTER_ERROR";

export const DOWNLOAD_STAFF_ACCOMMODATION_LETTER = "DOWNLOAD_STAFF_ACCOMMODATION_LETTER";
export const DOWNLOAD_STAFF_ACCOMMODATION_LETTER_SUCCESS = "DOWNLOAD_STAFF_ACCOMMODATION_LETTER_SUCCESS";
export const DOWNLOAD_STAFF_ACCOMMODATION_LETTER_ERROR = "DOWNLOAD_STAFF_ACCOMMODATION_LETTER_ERROR";

// Download document actions
export const DOWNLOAD_ACCOMMODATION_DOCUMENT = "DOWNLOAD_ACCOMMODATION_DOCUMENT";
export const DOWNLOAD_ACCOMMODATION_DOCUMENT_SUCCESS = "DOWNLOAD_ACCOMMODATION_DOCUMENT_SUCCESS";
export const DOWNLOAD_ACCOMMODATION_DOCUMENT_ERROR = "DOWNLOAD_ACCOMMODATION_DOCUMENT_ERROR";

// Config actions
export const LOAD_ACCOMMODATION_STATUSES = "LOAD_ACCOMMODATION_STATUSES";
export const LOAD_ACCOMMODATION_STATUSES_SUCCESS = "LOAD_ACCOMMODATION_STATUSES_SUCCESS";
export const LOAD_ACCOMMODATION_STATUSES_ERROR = "LOAD_ACCOMMODATION_STATUSES_ERROR";

export const LOAD_ACCOMMODATION_DOCUMENT_STATUSES = "LOAD_ACCOMMODATION_DOCUMENT_STATUSES";
export const LOAD_ACCOMMODATION_DOCUMENT_STATUSES_SUCCESS = "LOAD_ACCOMMODATION_DOCUMENT_STATUSES_SUCCESS";
export const LOAD_ACCOMMODATION_DOCUMENT_STATUSES_ERROR = "LOAD_ACCOMMODATION_DOCUMENT_STATUSES_ERROR";

// Filter actions
export const SET_ACCOMMODATION_REQUESTS_FILTERS = "SET_ACCOMMODATION_REQUESTS_FILTERS";

// UI state actions
export const RESET_STAFF_ACCOMMODATION_STATE = "RESET_STAFF_ACCOMMODATION_STATE";
export const CLEAR_STAFF_ACCOMMODATION_REQUEST_DETAIL = "CLEAR_STAFF_ACCOMMODATION_REQUEST_DETAIL";
